module.exports = __webpack_public_path__ + "img/info-gray.a9e32401.svg";